module.exports = __webpack_public_path__ + "media/images/flags/sd-836379c2140222b10910b4aaeea39657.svg";